import { useEffect } from "react";
import { useMap, useApiIsLoaded } from "@vis.gl/react-google-maps";

export const MapBoundsFitter = ({ locations = [] }) => {
  const map = useMap();
  const apiIsLoaded = useApiIsLoaded();
  
  useEffect(() => {
    if (!map || !apiIsLoaded || typeof window.google === 'undefined' || !window.google.maps) {
      return;
    }

    if (!locations || locations.length === 0) {
      return;
    }

    const bounds = new window.google.maps.LatLngBounds();
    let hasPoints = false;
    
    locations.forEach(location => {
      if (location && location.latitude != null && location.longitude != null) {
        bounds.extend(new window.google.maps.LatLng(location.latitude, location.longitude));
        hasPoints = true;
      }
    });
    
    if (hasPoints && !bounds.isEmpty()) {
      map.fitBounds(bounds);
    }
  }, [map, apiIsLoaded, locations]);
  
  return null;
};
